// i18n area 'networks' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/networks.sr-Latn-RS.meta.json.
import type { enUS } from './networks'

export const srLatnRS: typeof enUS = {
  networks: {
    common: {
      name: 'Ime',
      scope: 'Scope',
      operState: 'Stanje',
      actions: 'Akcije',
      create: 'Kreiraj',
      close: 'Zatvori',
      cancel: 'Otkaži',
      delete: 'Obriši',
      edit: 'Izmeni',
      save: 'Sačuvaj',
      editError: 'Izmena nije uspela',
      search: 'Pretraži po imenu',
      empty: 'Još ničega ovde',
      saveError: 'Nije moguće sačuvati',
      loadError: 'Nije moguće učitati — da li je TVirt backend dostupan?',
      createError: 'Kreiranje nije uspelo',
      deleteError: 'Brisanje nije uspelo',
      deleteConfirmTitle: 'Obrisati {name}?',
      deleteConfirmBody: 'Operacija je nepovratna.',
      nameHint: 'Mala slova, cifre i crtice (DNS-1123)',
      up: 'Aktivna',
      down: 'Neaktivna',
      unknown: 'Nepoznato',
      usedByVMs: 'VM',
      emptyTable: 'Nema stavki — dodajte jednu dugmetom +'
    },
    dialogTabs: {
      general: 'Opšte',
      base: 'Osnovna definicija',
      advanced: 'Napredna konfiguracija',
      reserved: 'Opsezi rezervisani za TVirt',
      position: 'Pozicija',
      network: 'Mrežna konfiguracija',
      hosts: 'Čvorovi učesnici'
    },
    reservedRanges: {
      note: 'Ovo su IP opsezi rezervisani za TVirt koje on može koristiti da automatski dodeli adresu VM-ovima, kontejnerima itd. NAPOMENA: adrese iz ovih opsega ne smeju van TVirta koristiti spoljni servisi ili uređaji.',
      from: 'Od',
      to: 'Do'
    },
    overlay: {
      title: 'Overlay mreže',
      createTitle: 'Kreirajte overlay mrežu',
      editTitle: 'Izmenite overlay mrežu',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — dodeljuje se automatski ako je prazno',
      subnet: 'Podmreža',
      subnetHint: 'CIDR overlaya — IPAM iz njega automatski izvodi svoju stavku registra',
      mtu: 'MTU',
      weight: 'Težina',
      ceilMbps: 'Plafon (Mbps)',
      fairnessHint: 'Težina važi samo pri zagušenju: na slobodnoj vezi svaka mreža može da koristi sav protok. Plafon važi uvek.',
      contention: 'Nadmetanje',
      contentionTip: 'Bar jedan čvor beleži odbacivanja ili overlimit-e SA redom čekanja na klasi ove mreže: propusni opseg uplink-a je osporavan i težine deluju. Koliko i otkad piše u serijama net.shaping.* čvora.',
      firewallPolicy: 'Firewall politika',
      hosts: 'Hostovi',
      hostsTitle: 'Čvorovi učesnici',
      hostsHint: 'Svaki čvor deklariše svoj underlay endpoint — select nad STVARNIM adresama čvora, pročitanim iz njegove mrežne konfiguracije; opciona overlay adresa mora biti unutar podmreže. Učešće je placement ograničenje.',
      hostNode: 'Čvor',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Prvo izaberite čvor',
      hostAddress: 'Adresa na overlayu (opciono)',
      hostAddressOutside: 'Izvan podmreže overlaya ({cidr})',
      addHost: 'Dodaj čvor',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Posmatrano',
      attachedNics: 'Prikačeni NIC-ovi'
    },
    services: {
      title: 'Mrežni servisi',
      createTitle: 'Kreirajte mrežni servis',
      editTitle: 'Izmenite mrežni servis',
      kind: 'Tip',
      kindCategory: 'Servisi',
      selectKindHint: 'Izaberite tip servisa — demon ispod je implementacioni detalj kojim TVirt upravlja za vas.',
      kindLabel: {
        dhcp: 'DHCP server',
        ntp: 'NTP server',
        vpn: 'VPN server',
        dns: 'DNS server',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer i reverse proxy',
        floatip: 'Plutajući IP'
      },
      kindDesc: {
        dhcp: 'Dodeljuje adrese na podmrežama koje služi — poolovi se izvode iz podmreže, gatewaya i opsega mreže rezervisanih za TVirt.',
        dns: 'Autoritativni DNS nad deklarisanim zonama — zapisi se izvode iz IPAM-a plus vaši ručni.',
        gateway: 'Čvor je gateway za mrežu — NAT (DNAT, 1:1, SNAT/masquerade) plus statičko rutiranje između prikačenih mreža, samopopravljivo po dizajnu.',
        'lb-rp': 'Balanser / obrnuti proksi ispred vaših servisa — L4 ili L7 slušaoci nad pulovima članova ili nad spremnim instancama Pod-a, rekonfigurisani u letu.',
        ntp: 'Vremenski servis mreža — relay spoljnih upstream servera, ili sopstveni sat čvora koji se služi klijentima.',
        vpn: 'VPN koncentrator na čvoru — WireGuard ili OpenVPN, po vašem izboru: udaljeni pristup za klijente u pokretu, ili site to site tunel između dve mreže.',
        floatip: 'Jedna adresa koja sedi na samo jednoj zdravoj App instanci ili Pod-u odjednom i seli se na sledeći zdrav cilj kada ovaj padne — failover bez demona; balansiranje ostaje balanseru.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Plutajući IP živi na izabranoj mreži kao DODATNA adresa unutar imenskog prostora instance koja ga drži: bez portova, bez balansiranja, bez NAT-a — IP klijenta ostaje pravi.',
        address: 'Plutajući IP',
        targets: 'Ciljevi',
        targetsHint: 'Redosledom PREFERENCIJE: prvi zdrav cilj drži adresu. Pod važi za sve svoje instance, po replici; svaki cilj ima sopstveni kriterijum zdravlja. Svaki cilj mora biti povezan na istu mrežu.',
        targetKind: 'Cilj',
        targetApp: 'App instanca',
        targetPod: 'Pod (sve instance)',
        targetRef: 'Koji',
        health: 'Zdravlje',
        healthRunning: 'Radi (svaki kontejner spreman)',
        healthTcp: 'TCP veza',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Putanja',
        addTarget: 'Dodaj cilj',
        moveUp: 'Pomeri gore',
        moveDown: 'Pomeri dole',
        preempt: 'Preempt',
        preemptHint: 'Isključeno (podrazumevano): zdrav držalac zadržava adresu i kada se viši cilj vrati — bez preskakanja. Uključeno: prvi zdrav cilj je uvek drži.',
        holder: 'Držalac',
        noHolder: 'nema zdravog cilja',
        since: 'od',
        verdicts: 'Posmatrani ciljevi',
        healthy: 'zdrav',
        unhealthy: 'nezdrav',
        noVerdict: 'Još nije odlučeno — čvor autoriteta upisuje prvu presudu u sledećem prolazu.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Ova instanca drži plutajući IP {address} servisa {service}'
      },
      poolSource: 'Krajnje tačke',
      poolSourceMembers: 'Statički članovi',
      poolSourcePod: 'Spremne instance Pod-a',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Krajnje tačke prate Pod: instanca ulazi kada radi sa svakim kontejnerom spremnim, izlazi odmah kada se smanji ili umre. Aktivna provera je podrazumevano uključena.',
      poolBackendCount: 'spremne instance Pod-a {pod} na portu {port}',
      node: 'Čvor',
      enabled: 'Omogućen',
      parked: 'Parkiran',
      subnets: 'Podmreže',
      subnetsHint: 'IPAM podmreže koje ova instanca služi — poolovi se izvode iz CIDR-a, gatewaya i opsega rezervisanih za TVirt',
      noSubnets: 'Nema IPAM podmreža — prvo deklarišite fabric logičku mrežu (ili overlay podmrežu): IPAM se izvodi iz njih',
      iface: 'Interfejs za slušanje',
      ifaceHint: 'Host interfejs na kojem servis otvara svoj socket (npr. bridge) — obavezan: mrežni servis je samostalan, „svi interfejsi“ više ne postoje',
      dns: 'DNS serveri',
      domain: 'Domen',
      detail: 'Služi',
      subnetCount: 'podmreža: {n}',
      zones: 'Zone',
      zonesHint: 'Samo autoritativno — demon nikada ne rekurzira. A zapisi se izvode iz deklarisanih adresa čvorova u referenciranim IPAM podmrežama; prekidač reverse služi i odgovarajuće in-addr.arpa zone (PTR). Jednu zonu služi najviše jedna DNS instanca u celoj floti. Opcioni nameserver je FQDN upisan u NS/SOA zapise umesto podrazumevanog ns.<zona>; ako pada unutar zone, njegov A zapis se svejedno izvodi iz čvora koji je služi.',
      zoneName: 'Ime zone',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM podmreže',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ručni zapisi',
      zoneRecordsHint: 'Jedan po redu: ime TIP vrednost — tipovi A, CNAME, MX, TXT. Pri koliziji imena ručni zapis pobeđuje izvedeni.',
      addZone: 'Dodaj zonu',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Instanca deklariše JEDNU mrežu za slušanje i JEDNU adresu — svaki listener je vezuje na svom portu; druga adresa je drugi servis.',
      listeners: 'Listeneri',
      listenersHint: 'Svaki listener vezuje adresu instance na svom portu u režimu L4 (TCP passthrough — bajtovi se nikada ne otvaraju) ili L7 (HTTP) i prosleđuje ka jednom od poolova ispod. Par adresa/port služi najviše jedna instanca po čvoru. Izmene se primenjuju u hodu — bez restarta, bez izgubljenih konekcija.',
      listenerName: 'Ime',
      listenerMode: 'Režim',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Dodaj listener',
      pools: 'Poolovi',
      poolsHint: 'Backendi na koje sleće saobraćaj: statički članovi balansirani round-robin ili po najmanje zauzetom, sa opcionom aktivnom health check proverom koja bolesne članove izbacuje iz rotacije.',
      poolName: 'Ime',
      poolAlgorithm: 'Algoritam',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Najmanje zauzet',
      poolCheck: 'Health check',
      checkNone: 'Nijedan',
      checkTcp: 'TCP konekcija',
      checkHttp: 'HTTP',
      poolCheckPath: 'Putanja sonde',
      poolInterval: 'Interval (s)',
      poolMembers: 'Članovi',
      poolMembersHint: 'Jedan po redu: adresa:port, opciono praćen težinom (1-128) — npr. 10.0.0.21:8080 2',
      addPool: 'Dodaj pool',
      memberCount: 'članova: {n}',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Dodela',
        assignmentStatic: 'Statička adresa',
        assignmentAuto: 'Automatska (TVirt rezervisani opsezi)',
        autoHint: 'TVirt izvlači adresu iz rezervisanih opsega logičke mreže i drži je sticky — nikad ponovo izvučena pri izmeni ili failoveru.',
        title: 'Listeneri',
        hint: 'Mrežni servis je samostalan: svaki listener deklariše svoju mrežu (overlay, fabric logička mreža ili interfejs) i adresu unutar njene podmreže — jedan listener po adresi, wildcard više ne postoji. DNS i NTP mogu slušati na više mreža i na više adresa tih mreža.',
        address: 'Adresa za slušanje',
        add: 'Dodaj listener'
      },
      ntp: {
        mode: 'Režim sinhronizacije',
        modeRelay: 'Relay spoljnih servera',
        modeNodeClock: 'Sopstveni sat čvora',
        modeHint: 'Relay služi vreme uzeto sa deklarisanih upstream servera; sopstveni sat čvora služi vreme čvora koji služi — koje klaster ionako drži sinhronizovanim',
        servers: 'Upstream serveri',
        serversHint: 'Odvojeni zarezom — hostname ili IP adresa; servis odavde uzima vreme i služi ga mreži',
        port: 'Port za slušanje',
        listening: 'Sluša na'
      },

      vpn: {
        engine: 'Motor',
        engineHint: 'Vi ga birate, i više se ne menja: WireGuard je moderan, brz i u kernelu; OpenVPN je veteran kompatibilnosti (TCP, neprijateljske mreže)',
        engineLocked: 'Motor je nepromenljiv — drugi motor je novi servis, njegovi ključevi i sertifikati nisu prenosivi',
        mode: 'Režim',
        modeRemote: 'Udaljeni pristup',
        modeSite: 'Site to site',
        modeHint: 'Udaljeni pristup daje klijentima u pokretu adresu u tunelu; site to site spaja dve mreže',
        port: 'Port za slušanje',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard govori samo UDP',
        tunnelSubnet: 'Podmreža tunela',
        tunnelSubnetHint: 'Mreža u kojoj žive klijenti — registrovana u IPAM registru, nastaje i umire sa ovim servisom',
        dnsServers: 'DNS gurnut klijentima',
        routes: 'Rute gurnute klijentima',
        routesHint: 'Mreže odvojene zarezom dostupne kroz tunel; podmreža tunela je uvek uključena',
        peers: 'Peerovi',
        peersHint: 'Ostavite javni ključ prazan i TVirt generiše par — potom ga isporučuje uz profil. Nalepite ključ i peer zadržava svoj.',
        clients: 'Klijenti',
        clientsHint: 'Svaki klijent dobija sertifikat izdat od CA ovog servisa. Uklanjanje klijenta ga OPOZIVA: CRL se odmah regeneriše.',
        peerName: 'Ime',
        publicKey: 'Javni ključ',
        publicKeyMinted: 'Generiše ga TVirt',
        peerAddress: 'Adresa u tunelu',
        peerAddressHint: 'Prazno = dodeljuje se',
        allowedIps: 'Udaljene podmreže',
        allowedIpsHint: 'Odvojene zarezom, rutirane kroz ovaj peer',
        endpoint: 'Endpoint',
        presharedKey: 'Unapred deljeni ključ',
        keepalive: 'Keepalive (s)',
        addPeer: 'Dodaj peer',
        addClient: 'Dodaj klijenta',
        auth: 'Autentifikacija',
        authTls: 'Sertifikati (TLS)',
        remote: 'Udaljeni endpoint',
        remoteHint: 'host:port udaljenog kraja — prazno znači da ova strana čeka',
        peerRoutes: 'Udaljene podmreže',
        serverPublicKey: 'Javni ključ ovog servera',
        ca: 'Sertifikaciono telo',
        listening: 'Sluša na',
        tunnel: 'Tunel',
        peerCount: 'peerova: {n}',
        download: 'Preuzmi profil',
        downloadError: 'Profil nije bilo moguće izvesti',
        lastHandshake: 'Poslednji handshake',
        never: 'nikada',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Povezan',
        idle: 'Neaktivan'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'Tip mreže za slušanje',
        attachOverlay: 'Overlay mreža',
        attachNetwork: 'Fabric logička mreža',
        attachInterface: 'Sirovi interfejs',
        overlay: 'Overlay mreža',
        network: 'Logička mreža',
        interface: 'Ime interfejsa',
        interfaceHint: 'Host interfejs kojim TVirt ne upravlja — adresa se uzima na poverenje',
        address: 'Adresa za slušanje (gateway)',
        addressHint: 'Gateway adresa na koju klijenti pokazuju — unutar podmreže mreže za slušanje',
        dnatTitle: 'DNAT pravila',
        dnatHint: 'Odredišni NAT: pogođeni saobraćaj se preusmerava na novu adresu (i opciono novi port). Bilo koji protokol sa liste — portovi tamo gde ih protokol nosi.',
        snatTitle: 'SNAT pravila',
        snatHint: 'Izvorni NAT: pogođeni saobraćaj izlazi sa prepisanim izvorom — eksplicitna nova adresa (i opciono novi port), ili masquerade na izlaznoj adresi ako se ostavi prazno.',
        oneToOneTitle: '1:1 NAT pravila',
        oneToOneHint: 'Svaki paket za spoljnu adresu preslikava se na unutrašnju, a unutrašnji host izlazi kao spoljna — svi protokoli, oba smera.',
        external: 'Spoljna adresa',
        internal: 'Unutrašnja adresa',
        addOneToOne: 'Dodaj 1:1 pravilo',
        family: 'Familija',
        protocol: 'Protokol',
        source: 'Izvor (adresa/podmreža)',
        destination: 'Odredište (adresa/podmreža)',
        invert: 'NOT',
        srcPorts: 'Izvorni portovi',
        dstPorts: 'Odred. portovi',
        dstPortsHint: 'Port ili opseg (80, 8000-8099)',
        toAddress: 'Nova adresa',
        toPort: 'Novi port',
        snatTo: 'Novi izvor (prazno = masquerade)',
        snatToHint: 'Eksplicitna izvorna adresa; prazno = masquerade na izlaznoj adresi',
        addDnat: 'Dodaj DNAT pravilo',
        addSnat: 'Dodaj SNAT pravilo',
        routesTitle: 'Statičke rute',
        routesHint: 'Čvor rutira između mreža na koje je prikačen (IP forwarding je uključen); ove rute dodaju dostupnost izvan njih — čist kernel, dinamičko rutiranje stiže sa kasnijim roundom.',
        routeDestination: 'Odredišna podmreža',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Dodaj rutu',
        listening: 'Sluša na',
        rules: 'DNAT: {d} · 1:1: {o} · SNAT: {s} · ruta: {r}'
      },
      unknownSince: 'Nepoznato — poslednji izveštaj pre {m} min',
      lastWord: 'Poslednja reč',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Poslednji izveštaj',
      lastErrorRow: 'Poslednja greška',
      recordsCount: 'ručnih zapisa: {n}',
      phase: {
        configured: 'Konfigurisan',
        running: 'U toku',
        error: 'Greška'
      },
      authorityNode: 'Authority (dodela)',
      preferredNode: 'Željeni čvor',
      preferredNodeHint: 'Meka preferencija, nikad ograničenje: pri sledećoj odluci o placementu instanca sleće ovde ako je član podoban — sama po sebi ne pomera ništa; potez je „Prenesi authority".',
      noPreference: 'Bez preferencije (automatski placement)',
      moving: 'U pokretu',
      movingTooltip: 'Posmatran ovde dok authority dodeljuje {node}: potez konvergira.',
      placement: {
        title: 'Placement',
        loading: 'Popis u toku…',
        loadError: 'Popis placementa nije odgovorio — pokušajte kasnije.',
        draftHint: 'Popis se računa nad deklarisanim mrežnim priključkom: pojaviće se kada servis bude napravljen. Kreiranje se odbija kada nijedan član ne može da ga služi, a odbijanje imenuje mehanizam koji je ispraznio skup.',
        eligibleCount: '{n} od {m} članova može da služi ovu instancu',
        recommended: 'Preporučen',
        eligible: 'Podoban',
        notEligible: 'Nije podoban',
        blockedReachability: 'mreža ne stiže do ovog člana',
        blockedRequireTag: 'blokiran obaveznim tagom (requireNodes)',
        blockedExcluded: 'isključen simulacijom',
        preferenceUnknown: 'nije (više) član klastera',
        preferenceIgnored: 'Preferencija „{node}" danas nije podobna: {reason}. Preovlađuje preporuka popisa — nikad greška, servis živi drugde.',
        emptyReachability: 'Nijedan član ne može da služi ovu instancu: mreža ne stiže nigde — nikakva izmena tagova neće pomoći. Kablirajte čvor, ili premestite servis tamo gde mreža postoji.',
        emptyRequireTag: 'Nijedan član ne može da služi ovu instancu: obavezni tagovi su ispraznili skup — uklonite stavku iz requireNodes, ili tagujte člana.',
        spof: 'Jedinstvena tačka otkaza',
        spofDetail: 'Samo jedan član može da ugosti instancu: pri otkazu failover nema kuda. Multi-listener servis se pomera kao CELINA — kandidat mora da vidi SVE njegove mreže: to je cena.',
        whatIf: 'Simuliraj odsutne članove',
        whatIfHint: 'What-if drena: pitajte PRE evakuacije, ne otkrivajte to pri failoveru.',
        survives: 'Sa odsutnim {nodes} servis i dalje ima dom.',
        notSurvives: 'Evakuacija {nodes} ostavlja ovaj servis OBOREN: izvedeno ograničenje pobeđuje dostupnost (R30) — demon živ tamo gde mreža ne stiže ne služi nikome i ne alarmira nikoga.',
        transfer: 'Prenesi authority',
        transferError: 'Prenos nije uspeo',
        transferTarget: 'Odredišni član',
        transferHint: 'Nude se samo podobni članovi — preferencija unutar važećeg skupa, nikad override. Bez taska: sledeći prolaz workera JESTE potez (stari čvor žanje, novi renderuje).'
      }
    },
    fabric: {
      tabDerivation: 'Derivacija',
      importNetwork: 'Uvezi iz drugog fabric-a',
      importTitle: 'Uvezi logičku mrežu',
      importHint: 'Uvoz je izričito pristupanje: mreža ostaje vlasnikova (isti identitet, isti stem, isti bridge tvf-<stem>) i odavde se mapira na portove/LAGG ovog fabric-a — mapirati ZNAČI tvrditi da isporuka izlazi u isti L2 domen kao vlasnikov.',
      importPick: 'Vlasnikova mreža',
      importNone: 'Nema šta da se uveze: drugi fabric-i nemaju sopstvenu mrežu koju ovaj fabric već ne poznaje',
      importedNetworksTitle: 'Uvezene mreže',
      noImported: 'Nema uvezene mreže',
      importedFrom: 'uvezena iz {fabric}',
      importedBy: 'Uvezena u: {list}',
      importedCount: '+{n} uvezenih',
      owner: 'Vlasnik',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Ukloni uvoz',
      unimportConfirm: 'Ukloniti uvoz mreže {name} (vlasnik {fabric}) iz ovog fabric-a? Odbija se dok je port ili LAGG ovog fabric-a mapira, ili dok se gost, App ili servis opslužuje samo kroz ovu nogu.',
      unimportRefused: 'Uvoz je još u upotrebi — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Ovaj čvor već uzima tu mrežu iz drugog fabric-a čiji je član: čvor uzima deljenu mrežu samo sa JEDNE svoje noge (dva uplink-a istog L2 u bridge-u bez STP-a su petlja). Odmapiraj je na portovima ili LAGG-u jednog od dva fabric-a.',
          otherFabricDerived: 'Dokument nosi blok fabric-a prema kojem čvor više ne deklariše kabl: prvo primeni plan tog fabric-a (predlaže uklanjanje njegovih uređaja), ili ih preuzmi sa take-ownership ako fabric više ne postoji.'
        },
        hint: 'Plan derivacije O.3: za svaki ožičeni čvor stanje, diff izvedeno-vs-trenutno, DEKLARISANA topologija bondova, dual-stack flipovi i strukturisana odbijanja/upozorenja. Samo za čitanje do EKSPLICITNOG apply-a — ništa nikada ne sleće na čvor samo.',
        refresh: 'Ponovo učitaj plan',
        empty: 'Nijedan čvor nije ožičen na ovaj fabric (i nijedan više ne nosi njegov blok).',
        refusal: 'Odbijanje',
        warning: 'Upozorenje',
        generation: 'generacija dokumenta {n}',
        state: {
          manual: 'Ručni',
          derived: 'Izveden',
          diverged: 'Odstupljen'
        },
        topologyTitle: 'Deklarisana topologija',
        members: 'članovi',
        primary: 'primarni',
        held: 'držan na JEDNOM članu',
        form: {
          perNetworkBond: 'Bond po mreži',
          singleBond: 'Jedan rezervni bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Jedan port'
        },
        colAction: 'Radnja',
        colKind: 'Vrsta',
        colDevice: 'Device',
        colDetail: 'Detalj',
        action: {
          add: 'dodaj',
          remove: 'ukloni',
          replace: 'zameni'
        },
        diffEmpty: 'Nema čekajućeg diffa — primenjeni dokument se poklapa sa renderom.',
        diffBlocked: 'Nema diffa: gornja odbijanja blokiraju ovaj čvor.',
        phasePlanned: 'planirano (korak 1 od 3)',
        phaseDraining: 'prazni se (korak 2 od 3)',
        probeUnobserved: 'Sonda pražnjenja: nikad prijavljena — praznina je NEPOZNATA (retire bi sada bio odbijen).',
        probeFailed: 'Sonda pražnjenja: posmatranje NEUSPELO — poznate vremenske oznake se prenose, nikad «prazno» koje niko nije izmerio.',
        probeActive: {
          one: 'Sonda: {n} uspostavljena veza još na staroj adresi',
          few: 'Sonda: {n} uspostavljene veze još na staroj adresi',
          other: 'Sonda: {n} uspostavljenih veza još na staroj adresi'
        },
        probeLastActive: 'poslednja aktivnost {time}',
        probeEmpty: {
          one: 'Sonda: prazno {n} minut',
          few: 'Sonda: prazno {n} minuta',
          other: 'Sonda: prazno {n} minuta'
        },
        probeEmptyUnknown: 'Sonda: prazno (otkad, nepoznato).',
        impact: '{nics} vNIC i {apps} App na ovom čvoru koriste ove mreže: {list}',
        apply: 'Primeni na ovaj čvor',
        applyTitle: 'Primeni derivaciju — {node}',
        applyIntro: 'Izvedena konfiguracija prepisuje mrežni dokument čvora {node} ({n} promena) kroz ista vrata kao editor host-network — uključujući NetworkManager checkpoint i poštenu sondu. Upozorenja plana ispod putuju sa činom: pročitajte ih pre potvrde.',
        applyError: 'Apply nije uspeo',
        applyRefused: 'Čvor je odbio:',
        planMoved: 'Fabric se promenio posle ovog pregleda — NIŠTA nije primenjeno. Plan je ponovo učitan: pogledajte ponovo i pokušajte opet.',
        retire: 'Povuci',
        retireTitle: 'Tačka bez povratka — povlačenje {address}',
        restore: 'Vrati',
        restoreTip: 'Nazad na snimak pre apply-a (generacija {previous}) — poništavanje u jednom koraku (H13)',
        restoreTitle: 'Vrati prethodni dokument — {node}',
        restoreIntro: 'Mrežni dokument čvora {node} vraća se na snimak napravljen pre poslednjeg apply-a (generacija {previous}), upisan kao generacija {next} umesto {current}. Worker ga usklađuje kao svaki drugi dokument.',
        restoreRedo: 'Zamenjeni dokument postaje novi snimak: ponovno vraćanje je redo.',
        restoreClosesChain: 'Snimak je ručni dokument pre derivacije: lanac se ovde zatvara — nema daljeg poništavanja, čvor je ručni do sledećeg apply-a.',
        restoreConfirm: 'Vrati',
        restoreError: 'Vraćanje nije uspelo',
        retireIntro: 'Ovo definitivno uklanja {address} ({network}) sa {point}. Posle ovog čina put nazad je OBRNUTI flip — ponovna deklaracija stare adrese kroz isti motor — nikad slepa obnova.',
        retireOld: 'Stara adresa (uklonjena)',
        retireNew: 'Nova adresa (ostaje)',
        retireEmptyFact: 'Sonda pražnjenja javlja adresu praznom: ovo uklanjanje ne prekida nijednu posmatranu vezu.',
        retireConfirm: 'Povuci adresu',
        severActiveLoss: {
          one: 'Prekini {n} uspostavljenu vezu još na staroj adresi — umire sa ovim činom',
          few: 'Prekini {n} uspostavljene veze još na staroj adresi — umiru sa ovim činom',
          other: 'Prekini {n} uspostavljenih veza još na staroj adresi — umiru sa ovim činom'
        },
        severUnknownLoss: 'Prihvati NEPOZNATO: sonda nikad nije posmatrala ovu adresu (ili posmatranje ne uspeva) — žive veze mogu biti prekinute.'
      },
      title: 'Fabric',
      createTitle: 'Kreirajte fabric',
      networks: 'Mreže',
      switches: 'Switchevi',
      ports: 'Portovi',
      laggs: 'LAGG-ovi',
      subnets: 'Podmreže',
      tabOverview: 'Pregled',
      tabNetworks: 'Logičke mreže',
      tabSwitches: 'Switchevi',
      overviewHint: 'Fabric na prvi pogled: svaka logička mreža sa svojim MTU i podmrežom (VLAN-ovi žive samo u mapiranjima po portu/po LAGG-u — ista mreža može putovati sa različitim tagovima na različitim portovima). Fabric je registar SPOLJNE infrastrukture — TVirt posmatra i deklariše, nikada ne vrši provisioning, i dodiruje samo NIC-ove registrovane pod njegovom kontrolom.',
      absorptionHint: 'Svaka podmreža deklarisana ovde IZVODI svoju stavku u IPAM registru u istom upisu — živi i umire sa mrežom.',
      scopeFixedHint: 'Scope je fiksiran na koren klastera: fizička infrastruktura je po definiciji na nivou celog klastera.',
      networksHint: 'Svaka mreža nosi obavezan MTU (podrazumevano 1500) i obaveznu podmrežu; gateway, DNS serveri i statičke rute deklarisani ovde su JEDINI IZVOR za NIC-ove servera, Aplikacije i mrežne servise.',
      switchesHint: 'Ručni registar: port je nekorišćen, mapiran (untagged i saobraćaj po VLAN tagu na logičke mreže) ili član LAGG-a — član ne nosi sopstvena mapiranja.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obavezan — IPAM iz njega automatski izvodi svoju stavku registra',
      nodeAddressing: 'Adresiranje čvorova',
      nodeAddressingNone: 'Ništa — bez adrese po čvoru',
      nodeAddressingPool: 'Pool — jedna trajna adresa po opsluženom čvoru',
      nodeAddressingHint: 'Sa Pool derivacija fabrika svakom opsluženom čvoru dodeljuje adresu iz opsega rezervisanih za TVirt (trajna nakon dodele).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Rezervisani opsezi',
      dns: 'DNS serveri (odvojeni zarezom)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS i rute deklarisani ovde su jedini izvor — NIC-ovi servera, Aplikacije i mrežni servisi crpe odavde',
      routesTitle: 'Statičke rute',
      routeDestination: 'Odredište (CIDR)',
      routeVia: 'Preko (next hop)',
      portUsed: 'Korišćen',
      vlanMappings: 'VLAN mapiranja',
      vlanTag: 'VLAN tag',
      vlanNetwork: 'Logička mreža',
      nameTaken: 'Ime je već upotrebljeno u fabricu',
      addNetwork: 'Dodaj mrežu',
      editNetwork: 'Izmeni mrežu',
      deleteNetwork: 'Ukloni mrežu',
      deleteNetworkConfirm: 'Ukloniti logičku mrežu {name} iz fabrica? Njena izvedena IPAM podmreža umire sa njom (odbija se dok je neki servis ili Aplikacija još koristi). Mapiranja na portovima i LAGG-ovima koja pokazuju na nju biće uklonjena.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fizička pozicija (opciono) — isti rečnik kao za pozicioniranje servera; samo deklarativno',
      addSwitch: 'Dodaj switch',
      editSwitch: 'Izmeni switch',
      deleteSwitch: 'Ukloni switch',
      deleteSwitchConfirm: 'Ukloniti switch {name} sa svim njegovim portovima? LAGG-ovi se shodno skupljaju (i umiru ispod dva porta).',
      addPort: 'Dodaj port',
      editPort: 'Izmeni port',
      deletePort: 'Ukloni port',
      deletePortConfirm: 'Ukloniti port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:mreža)',
      taggedShort: 'Tagged',
      portCabling: 'Kabliranje',
      portState: 'Stanje',
      stateUnused: 'nekorišćen',
      stateMapped: 'mapiran',
      laggPortGuard: 'Port koji je član LAGG-a menja se sa LAGG strane',
      laggsTitle: 'LAGG-ovi',
      laggsHint: 'LAGG je 2+ porta u LACP-u i može se protezati preko više switcheva (MLAG, transparentno); ulaze samo nekorišćeni portovi, LAGG je površina mapiranja, uklonjeni port se vraća u nekorišćene.',
      addLagg: 'Dodaj LAGG',
      editLagg: 'Izmeni LAGG',
      deleteLagg: 'Ukloni LAGG',
      deleteLaggConfirm: 'Ukloniti LAGG {name}? Njegovi portovi članovi vraćaju se u nekorišćene.',
      lacpRate: 'LACP rate',
      laggPorts: 'Portovi članovi (2+)',
      laggPortsHint: 'Ulaze samo nekorišćeni portovi — prvo oslobodite mapirani port',
      noNetworks: 'Nijedna logička mreža nije deklarisana.',
      noSwitches: 'Nijedan switch nije deklarisan.',
      noLaggs: 'Nijedan LAGG nije deklarisan.',
      staleConflict: 'Drugi operater je promenio ovaj fabric dok si ga uređivao: čuvanje je odbijeno da se ne obriše njegov rad. Tvoje izmene su i dalje ovde, netaknute. Ažurirani fabric je već ponovo učitan: potvrdi ponovo da ih primeniš preko njega, ili odustani i pogledaj šta se promenilo.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Samo izvedeno: svaka podmreža nastaje iz fabric logičke mreže ili iz overlaya — menja se na izvoru. Dodeljene adrese pokazuju KO ih drži; opsezi rezervisani za TVirt su poolovi automatske dodele.',
      search: 'Pretraga po imenu, CIDR-u ili adresi',
      empty: 'Nema mreža — deklarišite fabric logičku mrežu ili overlay podmrežu: IPAM se iz njih izvodi automatski.',
      reserved: 'Opsezi rezervisani za TVirt',
      address: 'Adresa',
      origin: 'Poreklo',
      origin_declared: 'deklarisano',
      origin_observed: 'posmatrano',
      holder: 'Drži je',
      noAddresses: 'Nijedna adresa u ovoj podmreži još nije poznata.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Izmeni na izvoru'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Firewall grupe',
      createTitle: 'Nova firewall grupa',
      editTitle: 'Izmenite firewall grupu',
      empty: 'Još nema firewall grupa — napravi jednu: rečnik pravila za višekratnu upotrebu, na koji se guest NIC-ovi pozivaju po imenu.',
      nameHint: 'Slova, cifre i . - _ u sredini; jedinstveno unutar svog scopea (istoimeni se drugde razlikuju po /scope/ime)',
      description: 'Opis',
      descriptionHint: 'Jedan red namere, prikazan svuda gde se grupa bira',
      enforced: 'Nametnuto scopeu',
      enforcedHint: 'Isključeno: čist rečnik — pravila vezuju samo NIC-ove koji se pozivaju na grupu. Uključeno: pravila vezuju svaki guest NIC sa uključenim firewallom pod scopeom grupe, sa referencom ili bez nje.',
      enforcedChip: 'Nametnuto',
      enforcedChipHint: 'Pravila vezuju svaki guest NIC sa uključenim firewallom pod scopeom grupe, sa referencom ili bez nje',
      enforceWarning: 'Uključivanjem nametanja pravila pri sledećem usklađivanju vezuju SVAKI guest NIC sa uključenim firewallom pod {scope}, i bez izričite reference — a unutar aktivnog chaina drop pretka je konačan: nivoi ispod ga ne otvaraju ponovo.',
      unenforceInfo: 'Uklanjanjem nametanja pravila ostaju samo na NIC-ovima koji se izričito pozivaju na grupu.',
      rules: 'Pravila',
      tabOverview: 'Pregled',
      tabRules: 'Pravila',
      orderHint: 'Redosled redova JESTE redosled vrednovanja unutar grupe: pobeđuje prvo pravilo koje se poklapa.',
      statefulHint: 'Stateful je implicitan: odgovori na dopušteni saobraćaj prolaze sami (established/related se prihvataju, invalid se odbacuje — ubacuje ih motor, ne pišu se ručno).',
      noRules: 'Nema pravila — rečnik u izgradnji: pozivanje na njega je dozvoljeno i ne proizvodi ništa.',
      addRule: 'Dodaj pravilo',
      direction: 'Smer',
      directionIn: 'Ulazni',
      directionOut: 'Izlazni',
      action: 'Akcija',
      action_accept: 'Prihvati',
      action_drop: 'Odbaci',
      action_reject: 'Odbij',
      protocol: 'Protokol',
      protocolAny: 'Bilo koji',
      ports: 'Portovi',
      source: 'Izvor',
      dest: 'Odredište',
      comment: 'Komentar',
      addressHint: 'IPv4 CIDR ili <fabric>/<logička mreža>; prazno = bilo koja',
      moveUp: 'Pomeri gore',
      moveDown: 'Pomeri dole',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Firewall grupe',
      nicGroupsPlaceholder: 'Izaberi grupu…',
      nicGroupsHint: 'Vidljive grupe, uključujući one nadređenih scopeova (upotrebljive nadole, kao tagovi)',
      nicGroupCount: { one: '{n} firewall grupa', few: '{n} firewall grupe', other: '{n} firewall grupa' },
      nicOff: 'Firewall isključen',
      pendingRestartHint: 'Izmene firewalla slede model sačuvano/primenjeno: čekaju sledeći power cycle (PendingRestart). Grupe nametnute od nadređenih scopeova primenjuju se kad je firewall NIC-a uključen.',
      appConvergeHint: 'Izmene firewalla primenjuju se pri sledećem usklađivanju kontejnera. Grupe nametnute od nadređenih scopeova primenjuju se kad je firewall uključen.',
      enforcedAncestors: 'Nametnute od nadređenih scopeova',
      enforcedAncestorsHint: 'Ova grupa se primenjuje na svaki NIC pod svojim scopeom sa UKLJUČENIM firewallom — prekidač je glavni prekidač NIC-a (isključeno = nikakav chain, preci uključeni); unutar aktivnog chaina autoritet pretka je konačan: njegov drop se ispod ne otvara ponovo.'
    }
  }
}
